// extracted by mini-css-extract-plugin
export var cartContainer = "_hs-4";
export var gray = "_hs-1";
export var itemContainer = "_hs-2";
export var itemDetails = "_hs-3";
export var strong = "_hs-0";